import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import withWidth from 'material-ui/utils/withWidth'
import compose from 'recompose/compose'
import Hidden from 'material-ui/Hidden'
import {Tab as MUITab} from 'material-ui/Tabs'
import {Tabs} from '../../../components'
import IconAnnouncement from 'material-ui-icons/Announcement'
import IconEvent from 'material-ui-icons/Event'

import styles from '../styles'
import {container as text} from '../text'
import {tabs} from '../reducers/container'
import CommonContainer from '../../../common/components/Container'
import ActivityTab from '../containers/activity'
import AppointmentsTab from '../containers/appointments'

class Container extends React.Component {

  handleChange = (e, v) => {
    this.props.setTab(v)
  }

  render() {
    const {tab} = this.props
    return (
      <CommonContainer>
        <Hidden only={['md', 'lg', 'xl']}>
          <Tabs value={tab} onChange={this.handleChange}>
            <MUITab icon={<IconAnnouncement/>}/>
            <MUITab icon={<IconEvent/>}/>
          </Tabs>
        </Hidden>
        <Hidden only={['xs', 'sm']}>
          <Tabs
            value={tab}
            onChange={this.handleChange}
            scrollButtons="auto"
          >
            <MUITab label={text.tabActivity} value={tabs.ACTIVITY}/>
            <MUITab label={text.tabAppointments} value={tabs.APPOINTMENTS}/>
          </Tabs>
        </Hidden>
        {tab === tabs.ACTIVITY ? <ActivityTab/> : null}
        {tab === tabs.APPOINTMENTS ? <AppointmentsTab/> : null}
      </CommonContainer>
    )
  }

  static propTypes = {
    tab: PropTypes.number.isRequired,
    setTab: PropTypes.func.isRequired,
  }
}

export default compose(withStyles(styles, {withTheme: true}), withWidth())(Container)



// WEBPACK FOOTER //
// ./src/sections/activity/components/container.js